import Logger from '~/Helper/Logger'

Logger.console.log('%cbody script executed', 'color:orange')
